module.exports = __webpack_public_path__ + "img/img_right.aa965836.jpg";